import { FC } from 'react';
import { getSubdomain } from 'utils/helpers/routing';
import { getUserInfo } from 'utils/auth';

import NotAuthorizedScreen from 'routes/not-authorized';
import InnerWrapper from '../InnerWrapper';
import CreateForm from './components/CreateForm';

const Screen: FC = () => {
  const isOperator = getSubdomain() === 'operators';
  const isWorkTripsActive = getUserInfo().featureWorkTrips;

  if (isWorkTripsActive && !isOperator) {
    return (
      <InnerWrapper>
        <CreateForm />
      </InnerWrapper>
    );
  }

  return <NotAuthorizedScreen />;
};

export default Screen;
